import { component } from 'picoapp';

export default component((node, ctx) => {
  setTimeout(() => {
    node.classList.add('is-active');
  }, 800);

  const scroller = node.querySelector('.js-slide');

  setTimeout(() => {
    scroller.classList.add('is-active');
  }, 3500);
});
